import { useSelector } from "react-redux";

export const useBookTransation = (bookId) => {
  const translate = useSelector((state) => state.translate.translations[bookId]);
  return translate;
};
